(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    // Shopify bundles this block's JavaScript once, not once per card.
    // The guard also prevents duplicate listeners in an editor re-evaluation.
    const installKey = '__wfpCardMediaClickGuardV1';
    if (window[installKey]) return;
    window[installKey] = true;

    const controls = [
      'button',
      'input',
      'select',
      'textarea',
      'label',
      'summary',
      '[role="button"]',
      '[contenteditable]:not([contenteditable="false"])',
      'quick-add-component',
      'slideshow-arrows',
      'slideshow-controls',
      'model-viewer'
    ].join(',');

    const getGallery = (target) => {
      if (!(target instanceof Element)) return null;
      if (target.closest(controls)) return null;
      return target.closest('product-card .card-gallery');
    };

    document.addEventListener('mousedown', (event) => {
      const gallery = getGallery(event.target);
      if (!gallery) return;

      const scroller = event.target.closest('slideshow-slides');
      if (!scroller || !gallery.contains(scroller)) return;

      // Block ONLY the mouse-down path into Horizon's drag handler.
      // Do not cancel the default action, intercept clicks or navigate here.
      // Real touch swipes use native touch scrolling, which is untouched.
      event.stopPropagation();
    }, { capture: true });

    document.addEventListener('dragstart', (event) => {
      if (!getGallery(event.target)) return;
      // Stop the browser's separate image/link drag ghost on card media.
      event.preventDefault();
    }, { capture: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
